import React, { useEffect, useState } from 'react';
// @mui
import { Box, Button, MenuItem, Stack, Typography, useTheme } from '@mui/material';
// hooks
import useLocales from '../../../hooks/useLocales';
// components
import Image from '../../../components/Image';
import MenuPopover from '../../../components/MenuPopover';
import { useSelector } from '../../../redux/store';
import { updateHeaders } from '../../../utils/connection-assistant';
import useResponsive from '../../../hooks/useResponsive';
import Iconify from '../../../components/Iconify';
import CustomModal from '../../../components/CustomModal';
import palette from '../../../theme/palette';
import MobileLanguageDrawer from './MobileLanguageDrawer';

// ----------------------------------------------------------------------

export default function LanguagePopover({
  sx = {},
  CustomBtn,
  PopoverProps = {},
  isMobile,
  isCollapse,
  isDrawerOpen = false,
}) {
  const theme = useTheme();

  const { allLangs, currentLang, onChangeLang, translate } = useLocales();

  const { siteSettings } = useSelector((x) => x.lookup);

  const [customLangs, setCustomLangs] = useState([]);

  const [open, setOpen] = useState(null);

  const [selectedLang, setSelectedLang] = useState(currentLang);

  const domainLocale = process.env.REACT_APP_LOCALE;

  const langStorage = localStorage.getItem('i18nextLng');

  const [openDrawer, setOpenDrawer] = useState(false);

  useEffect(() => {
    // setCustomLangs(allLangs.filter((f) => f?.value === 'en' || f?.value === domainLocale));
    if (siteSettings?.languages?.length > 0) {
      const matchingLangs = allLangs;
      // I JUST COMMENT THIS TEMPORARILY
      // .filter((obj1) =>
      //   siteSettings?.languages.some((obj2) => obj1?.value === obj2.locale)
      // );
      if (matchingLangs) {
        setCustomLangs(matchingLangs);

        if (matchingLangs.findIndex((ml) => ml?.value === langStorage) === -1) {
          handleChangeLang(matchingLangs.find((f) => f?.value === domainLocale)?.value);
          console.log('matching');
        }
      } else {
        console.log('No Matching languages');
      }
    }
  }, [siteSettings?.languages]);

  // useEffect(() => {
  //   const queryString = window.location.search;

  //   const urlParams = new URLSearchParams(queryString);

  //   setParamLang((prev) => {
  //     if (!prev) {
  //       return urlParams.get('lang');
  //     }
  //     return '';
  //   });
  // }, []);

  // useEffect(() => {
  //   if (customLangs?.length && paramLang) {
  //     const isExist = customLangs.find((x) => x?.value === paramLang.toLowerCase());

  //     if (isExist) {
  //       handleChangeLang(isExist??.value);
  //       setParamLang('');
  //     }
  //   }
  // }, [customLangs, paramLang]);

  useEffect(() => {
    console.log(currentLang);
  }, [currentLang]);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleChangeLang = (newLang) => {
    localStorage.setItem('i18nextLng', newLang);
    onChangeLang(newLang);
    handleClose();
    // updateHeaders({ 'X-Language': newLang });
    // window.location.reload();
  };

  return (
    <>
      {isMobile ? (
        <>
          <Stack
            direction={'row'}
            spacing={1}
            sx={{ background: theme.palette.primary.light, p: '5px 10px', borderRadius: '50px', cursor: 'pointer' }}
            onClick={(e) => {
              if (isMobile && isDrawerOpen) {
                setOpenDrawer(true);
              } else {
                handleOpen(e);
              }
            }}
          >
            <Image src={require('../../../assets/header/chat.png')} sx={{ height: '20px', width: '22px' }} />
            <Typography sx={{ fontSize: '12px' }}>{currentLang?.value?.toUpperCase()}</Typography>
          </Stack>
        </>
      ) : (
        <>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: isCollapse ? 'center' : 'space-between',
              background: palette.button.secondary,
              borderRadius: '8px',
              height: '46px',
              px: isCollapse ? 0 : 1.5,
              width: '100%',
              cursor: 'pointer',
            }}
            onClick={(e) => handleOpen(e)}
          >
            {/* LEFT SIDE */}
            {!isCollapse ? (
              <Box sx={{ flex: 1 }}>
                {CustomBtn ? (
                  React.cloneElement(CustomBtn, { title: currentLang?.label })
                ) : (
                  <Button
                    variant="text"
                    startIcon={
                      <Image
                        disabledEffect
                        src={currentLang?.icon}
                        alt={currentLang?.label}
                        sx={{
                          width: 28,
                          maxHeight: '20px',
                          img: { objectFit: 'contain' },
                        }}
                      />
                    }
                    sx={sx}
                    size="small"
                  >
                    <Typography sx={{ color: '#8991A7' }} fontWeight={600}>
                      {currentLang?.value?.toUpperCase()}
                    </Typography>
                  </Button>
                )}
              </Box>
            ) : (
              <Image
                disabledEffect
                src={currentLang?.icon}
                alt={currentLang?.label}
                sx={{
                  width: 24,
                  height: 20,
                  img: { objectFit: 'contain' },
                }}
              />
            )}

            {/* RIGHT SIDE (arrow only when expanded) */}
            {!isCollapse && <Iconify icon={'iconoir:nav-arrow-down'} sx={{ color: '#8991A7' }} />}
          </Box>
        </>
      )}

      {/* <MenuPopover */}
      {isMobile && isDrawerOpen ? (
        <MobileLanguageDrawer
          open={openDrawer}
          onClose={() => setOpenDrawer(false)}
          languages={customLangs}
          currentLang={currentLang}
          onSelectLang={handleChangeLang}
        />
      ) : (
        <CustomModal
          open={Boolean(open)}
          onClose={handleClose}
          maxWidth={'xs'}
          paperPropsSx={{
            '& .MuiMenuItem-root': { px: 3, typography: 'body2', borderRadius: 0.75, color: '#000' },
          }}
          title={<Typography sx={{ color: '#000', fontWeight: 900 }}>{translate('please_select_lang')}</Typography>}
        >
          <Stack spacing={0.75} sx={{ py: 1 }}>
            {customLangs.map((option) => (
              <MenuItem
                key={option?.value}
                selected={option?.value === currentLang?.value}
                onClick={() => {
                  handleChangeLang(option?.value);
                  setSelectedLang(option);
                }}
              >
                <Image
                  disabledEffect
                  alt={option.label}
                  src={option.icon}
                  sx={{
                    width: 28,
                    height: 20,
                    mr: 2,
                    img: { objectFit: 'contain' },
                  }}
                />
                {option.label}
              </MenuItem>
            ))}
          </Stack>
        </CustomModal>
      )}
    </>
  );
}
